let variantSize
let variantProductId
let currentVariant = null
let variantColor
$(document).ready(function(){
    var url = new URL(window.location.href);
    var variantId = url.searchParams.get('variant');
    if (variantId !== null) {
        var variantsInfo = JSON.parse(document.getElementById('variants_data').textContent);
        for(const variant of variantsInfo){
            if(variant.id == variantId){
                variantProductId = variant.product
                variantSize = variant.options[0]
                variantColor = variant.color
                const productId = variant.product
                mp_show_images(productId)
                mp_update_sizes()
                mp_select_variant()
                $('.labellll').each(function(){
                    if($(this).attr('secondproduct') == variantProductId){
                        $(this).addClass('round-border')
                    }
                })
                $('.pills-variant-labels').each(function(){
                    if($(this).attr('val').toUpperCase() == variantSize && !$(this).hasClass('disabled')){
                        $(this).addClass('round-border')
                    }
                    if($(this).attr('val').toUpperCase() == variantSize && $(this).hasClass('disabled')){
                        $('.product-form__submit').attr('disabled','disabled')
                        $('.add_to_cart_quantity').text('Agotado')
                    }
                })
                changeZoomSliderImages(variantColor)
            }
        }
    }
    else{
      console.log('No hay variante seleccionada')
      $('label[name="TALLA"]').each(function () {
        const $label = $(this);
        const $input = $label.prev('input');
      
        if (!$input.hasClass('disabled')) {
          console.log($label)
          setTimeout(() => {
            $label.trigger('click');
          }, 200);
          return false;
        }
      });
    }
    $('.input-variant').on('click',function(){
        if($(this).attr('name') == 'TALLA'){
            variantSize = $(this).attr('val')
            $('.pills-variant-labels').removeClass('round-border')
        }
        if($(this).attr('name') == 'COLOR'){
            variantProductId = $(this).attr('secondproduct')
            const productId = $(this).attr('secondproduct')
            mp_show_images(productId)
            $('.labellll').removeClass('round-border')
            changeZoomSliderImages($(this).attr('val'))
            setTimeout(() => {
            let sublistSwiper2 = document.querySelector('.js-media-sublist').swiper;
            sublistSwiper2.slideTo(5,0)
            sublistSwiper2.slideTo(0,0)
            console.log('Se actualizó')
            }, 200);
        }
        mp_update_sizes()
        $(this).addClass('round-border')
        mp_select_variant()
    })
})


function changeZoomSliderImages(color){
    console.log('bloquea las imagenes')
    $('.s3 [data-color]').each(function() {
        if ($(this).attr('data-color') != color) {
            $(this).css('display', 'none');
        } else {
            $(this).css('display', 'flex');
        }
    });
}

function mp_show_images(productId){
    Array.prototype.forEach.call(document.querySelectorAll(".js-media-sublist [data-element]:not([data-element='" + productId + "'])"), (e) => {
        e.classList.add("non-swiper-slide"), e.classList.remove("swiper-slide"), e.removeAttribute("style");
    }),
    Array.prototype.forEach.call(document.querySelectorAll(".js-media-sublist [data-element='" + productId + "']"), (e) => {
        e.classList.remove("non-swiper-slide"), e.classList.add("swiper-slide"), e.removeAttribute("style");
    }),
    Array.prototype.forEach.call(document.querySelectorAll(".js-media-list [data-element]:not([data-element='" + productId + "'])"), (e) => {
        e.classList.add("non-swiper-slide"), e.classList.remove("swiper-slide"), e.removeAttribute("style");
    }),
    Array.prototype.forEach.call(document.querySelectorAll(".js-media-list [data-element='" + productId + "']"), (e) => {
        e.classList.remove("non-swiper-slide"), e.classList.add("swiper-slide"), e.removeAttribute("style");
    });
}
function mp_select_variant(){
  if(variantSize == undefined){
    $('label[name="TALLA"]').click()
  }
    var variantsInfo = JSON.parse(document.getElementById('variants_data').textContent);
    for(const variant of variantsInfo){
        if(variant.options.includes(variantSize) && variant.product == variantProductId){
            if(variant.available){
                currentVariant = variant.id
                variantColor = variant.color
            }
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.href);
            $('.product__sku').html('<span class="visually-hidden">SKU:</span>'+variant.sku+'</p>')
            var price = variant.price
            console.log(variant)
            console.log('no compare ',variant.compare_at_price)
            let sizes = []
            for(const variant of variantsInfo){
                if(variant.product == variantProductId){
                    if(variant.available){
                        sizes.push(variant.options[0])
                    }
                }
            }
            if(variant.compare_at_price){
                console.log('compare ',variant.compare_at_price)
                $('.price-item.price-item--regular').text(variant.compare_at_price)
                $('.price-item.price-item--sale').text(variant.price)
                $('.price__sale').css('display','flex')
                $('.price__regular').css('display','none')
                $('.product .price').addClass('price--on-sale')
                $('.badge--bottom-left').css('display','inline-block')
                $('.badge--bottom-left').text('-'+ (100-parseInt(parseFloat(variant.price.replace('$ ','').replace(',',''))*100/parseFloat(variant.compare_at_price.replace('$ ','').replace(',',''))))+'%')
            }
            else{
                $('.badge--bottom-left').css('display','none')
                $('.price-item.price-item--regular').text(price)
                $('.product .price').removeClass('price--on-sale')
                $('.price__sale').css('display','none')
                $('.price__regular').css('display','flex')
            }
            $('.availability.product-about__outer h2 span').css('font-weight','normal')
            if(sizes.length == 0){
              $('.product__media-list .badge--bottom-left').css('display','inline-block')
              $('.product__media-list .badge--bottom-left').text('AGOTADO')
              $('.availability.product-about__outer h2 span').css('font-weight','bold')
              if(!$('.availability.product-about__outer h2').hasClass('active')){
                $('.availability.product-about__outer h2').click()
              }
            }
        }
    }
}
function mp_update_sizes(){
    var variantsInfo = JSON.parse(document.getElementById('variants_data').textContent);
    let sizes = []
    for(const variant of variantsInfo){
        if(variant.product == variantProductId){
            if(variant.available){
                sizes.push(variant.options[0])
            }
        }
    }
    let available = true
    $('#SingleOptionSelector-0 input').each(function(){
        if(sizes.includes($(this).val())){
            $(this).removeClass('disabled')
        }
        else{
            $(this).addClass('disabled')
            if(variantSize == $(this).attr('val')){
                available = false
            }
        }
    })
    console.log(available)
  console.log(sizes)
    if(!available){
      console.log('No está disponible')
        console.log($('.labellll *[val="'+variantSize+'"]'))
        $('*[val="'+variantSize+'"].pills-variant-labels').removeClass('round-border')
        $('.product-form__submit').attr('disabled','disabled')
        $('.product-form__submit').text('Agotado. Puedes buscar la disponibilidad de este producto en tienda física')
        currentVariant = null
    }
    else{
        $('*[val="'+variantSize+'"].pills-variant-labels').addClass('round-border')
        $('.product-form__submit').removeAttr('disabled')
        $('.product-form__submit').text('AGREGAR A MI BOLSA')
    }
}

function mp_add_to_cart(){
    const color = variantColor
    const size = variantSize
    const product = currentVariant

    let config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const cart = document.querySelector("cart-drawer")
    const formData = new FormData();
    formData.append('TALLA', size);
    formData.append('COLOR', color);
    formData.append('form_type', 'product'); 
    formData.append('id', product);
    //formData.append('properties', JSON.stringify({"color":color}));
    formData.append('quantity', $('.quantity__input').val());
    if (cart) {
        formData.append(
            "sections",
            cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        cart.setActiveElement(document.activeElement);
    }
    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
        ncaddToken()
        uploadCart() 
        console.log(this)
        if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
            if (!soldOutMessage) return;
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButton.querySelector("span").classList.add("hidden");
            soldOutMessage.classList.remove("hidden");
            this.error = true;
            return;
        } else if (!cart) {
            window.location = window.routes.cart_url;
            return;
        }

        if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
            });
        this.error = false;
        const quickAddModal = document.querySelector("quick-add-modal");
        if (quickAddModal) {
            document.body.addEventListener(
                "modalClosed",
                () => {
                    setTimeout(() => {
                        cart.renderContents(response);
                    });
                },
                { once: true }
            );
            quickAddModal.hide(true);
        } else {
            cart.renderContents(response);
        }
    })
    .catch((e) => {
        console.error(e);
    })
}